<template>
    <div class="hpc-container">
        <Form ref="hpcForm"
              :model="formData"
              :rules="rules"
              :label-colon="true"
              :hide-required-mark="false"
              label-position="right"
              :label-width="90">
            <!-- 基础配置 -->
            <div class="instance-item"
                 style="border-top:1px dashed #e9e9e9;border-bottom:0">
                <!-- <div class="instance-item-left"><i class="icon-system-settings-o instance-item-icon"></i><span>{{$t('基础配置')}}</span></div> -->
                <div class="instance-item-right">
                    <FormItem :label="$t('计费类型')"
                              prop="billingType">
                        <RadioGroup type="button"
                                    v-model="formData.billingType"
                                    @on-change="getpackageData">
                            <Radio v-for="(item,index) in defaultChargeTypeData"
                                   :key="index"
                                   :label="item.value"
                                   :disabled="!item.checked"
                                   border>{{item.name}}</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem :label="$t('套餐类型')"
                              prop="type">
                        <RadioGroup type="button"
                                    v-model="formData.type"
                                    @on-change="getpackageData">
                            <Radio v-for="(item,index) in availableZonesList"
                                   :key="index"
                                   :label="item.value"
                                   border>{{item.name}}</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem :label="$t('适用产品')"
                              prop="productType">
                        <RadioGroup type="button"
                                    v-model="formData.productType"
                                    @on-change="changeSpec">
                            <Radio v-for="(value,key,index) of configData"
                                   :key="index"
                                   :label="JSON.stringify(value)+'|'+key"
                                   border>{{key}}</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem :label="$t('规格')"
                              prop="specValue">
                        <RadioGroup type="button"
                                    v-model="formData.specValue"
                                    @on-change="changeTime">
                            <Radio v-for="(value,key,index) of specData"
                                   :key="index"
                                   :label="JSON.stringify(value)"
                                   border>{{key}}</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem prop="quantity"
                              :label="$t('购买数量')">
                        <InputNumber :max="Number(maxTimesStorage)"
                                     :min="Number(minTimesStorage)"
                                     :step="1"
                                     :formatter="value=>parseInt(value)"
                                     :active-change="true"
                                     v-model="formData.quantity"
                                     @on-change="getpackageData"></InputNumber>
                        <p style="color:#999999">{{$t('如您购买的数量为多个，则最终时长顺延。如：购买数量2，购买时长为1个月，则最终为可使用时间2个月。')}}</p>
                    </FormItem>
                    <FormItem :label="$t('购买时长')">
                        <RadioGroup type="button"
                                    v-model="formData.timesId"
                                    @on-change="changebuyTime">
                            <!--    getpackageData -->
                            <Radio v-for="(item,index) in timeList"
                                   :key="index"
                                   :label="item.id"
                                   border>{{item.period%12 === 0?item.period/12+$t('年'):item.period+$t('个月')}}</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem v-if="showCoupon"
                              style="margin-bottom: 10px;">
                        <Checkbox v-model="formData.isCoupon"
                                  @on-change="changeCoupon">{{$t('使用优惠券')}}</Checkbox>
                        <Select style="width:200px;margin-left:20px;"
                                v-if="formData.isCoupon"
                                v-model="formData.couponId"
                                :transfer="true"
                                clearable
                                @on-clear="clearCouponValue"
                                @on-change="changeCouponValue">
                            <Option v-for="(item, index) in couponData"
                                    :key="index"
                                    :disabled="item.reductionCondition> parseInt(quiryPrice)"
                                    :value="item.couponSid">{{item.text}}</Option>
                            <!-- (item.discountAmount > parseInt(quiryPrice))|| -->
                        </Select>
                    </FormItem>
                </div>
            </div>
        </Form>
        <discountmodal ref="discountmodal"
                       :titleTxt="$t('确定要继续购买吗？') "
                       :contentTxt="$t('您使用的优惠券金额大于订单金额，超出的优惠金额将不退还。')"
                       @modalFun="modalFun"></discountmodal>
    </div>
</template>

<script>
import API from '@/service/api.js'
import { formatDateTime } from '@/service/utils'
import discountmodal from '@/views/portal/application/components/discountmodal.vue'
export default {
    name: 'packageform',
    components: {
        discountmodal
    },
    props: {
        configData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        quiryPrice: { // 商品价格
            type: Number,
            default: 0
        }
    },
    data () {
        return {
            clusterId: null,
            maxTimesStorage: 1000,
            minTimesStorage: 1,
            formData: {
                billingType: 'PrePaid',
                type: 'discount',
                quantity: 1,
                productType: '',
                productName: '',
                specValue: '',
                timesId: '',
                isCoupon: false,
                couponId: '',
                discount: null // 折扣
            },
            showCoupon: true,
            couponData: [], // 优惠券
            availableZonesList: [
                {
                    name: this.$i18n.t('折扣包'),
                    value: 'discount'
                }
                //  {
                //     name: this.$i18n.t('资源包'),
                //     value: 'resouce'
                // }
            ],
            defaultChargeTypeData: [
                // {
                //     name: this.$i18n.t('按量计费'),
                //     value: 'PostPaid',
                //     checked: true
                // }
                {
                    name: this.$i18n.t('包年包月'),
                    value: 'PrePaid',
                    checked: true
                }
            ],
            specData: [],
            timeList: [],
            rules: {
                quantity: [
                    { type: 'number', required: true, message: '该字段不能为空', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: this.$t('该字段不能为空'), trigger: 'change' }
                ],
                billingType: [
                    { required: true, message: this.$t('该字段不能为空'), trigger: 'change' }
                ],
                productType: [
                    { required: true, message: this.$t('该字段不能为空'), trigger: 'change' }
                ],
                specValue: [
                    { required: true, message: this.$t('该字段不能为空'), trigger: 'change' }
                ]
                // timesId: [
                //     { required: true, message: this.$t('该字段不能为空'), trigger: 'change' }
                // ]
            }
        }
    },
    watch: {
        configData: {
            immediate: true,
            handler (val) {
                if (val) {
                    const key = Object.keys(val)[0]
                    this.formData.productType = JSON.stringify(val[key]) + '|' + key// 默认数据 取第一个的键值
                    this.formData.productName = key
                    this.changeSpec(this.formData.productType)
                }
            }
        },
        clusterId (val, oldval) {
            if (val && val !== oldval && this.formData.isCoupon) {
                this.couponData = []
                this.changeCoupon()
            }
        }
    },
    computed: {
    },
    created () {
    },
    mounted () {

    },
    methods: {
        changeSpec (value) {
            if (value) {
                const arr = value.split('|')
                this.specData = JSON.parse(arr[0])
                this.formData.productName = arr[1]
            } else {
                this.specData = this.configData[Object.keys(this.configData)[0]]
            }
            const key = Object.keys(this.specData)[0]
            this.formData.specValue = key !== null ? JSON.stringify(this.specData[key]) : null
            // 默认选中购买时长
            this.$nextTick(() => {
                if (key !== null) {
                    this.changeTime(this.formData.specValue)
                }
            })
        },
        changeTime (value) {
            if (value) {
                const data = JSON.parse(value)
                this.clusterId = data.length > 0 ? data[0].clusterId : null
                this.timeList = data
            } else {
                this.timeList = this.configData[Object.keys(this.configData)[0]]
            }
            this.formData.timesId = null
            // 修改折扣时需要把优惠券删除
            this.$nextTick(() => {
                if (this.timeList instanceof Array) return this.changebuyTime(this.timeList[0].id)
            })
        },
        // 改变购买时长
        changebuyTime (val) {
            this.formData.timesId = val
            // 修改折扣时需要把优惠券删除
            this.clearCouponValue()
        },
        // 优惠卷组装
        changeCoupon () {
            this.formData.couponId = null
            this.formData.discount = null
            this.couponData = []
            if (this.formData.isCoupon) {
                const time = new Date()
                this.axios.get(this.urlFormat(API.COUPONS_ACCOUNTS), {
                    params: {
                        clusterId: this.clusterId || null,
                        couponStatus: 'unused',
                        startTimeLe: time ? formatDateTime(time) : '',
                        endTimeGe: time ? formatDateTime(time) : ''
                    }
                }).then((result) => {
                    if (result.dataList && result.dataList.length > 0) {
                        // 过滤满足当前价格的优惠券
                        const newList = result.dataList
                        newList.forEach(item => {
                            item.text = item.reductionCondition ? '（' + this.$t('满') + item.reductionCondition + this.$t('减') + item.discountAmount + '）' + this.$t('￥') + item.discountAmount + this.$t('优惠券') : '（' + this.$t('无限制') + '）' + this.$t('￥') + item.discountAmount + this.$t('优惠券')
                        })
                        this.couponData = newList
                    } else {
                        this.couponData = []
                        this.formData.couponId = null
                        this.formData.discount = null
                        this.getpackageData()
                    }
                })
            } else {
                this.getpackageData()
            }
        },
        // 清空优惠券
        clearCouponValue () {
            this.formData.couponId = null
            this.formData.discount = null
            this.getpackageData()
        },
        // 选择优惠券
        changeCouponValue (val) {
            const data = this.getOne(val, this.couponData, 'couponSid')
            this.formData.discount = data ? data.discountAmount : null
            if (data && data.discountAmount && data.discountAmount > this.quiryPrice) {
                this.$refs.discountmodal.openModal()
            } else {
                // 优惠券小于总金额时，直接询价
                this.getpackageData()
            }
        },
        // 优惠卷价格大于总价时得弹出确认框
        modalFun () {
            const data = this.getOne(this.formData.couponId, this.couponData, 'couponSid')
            this.formData.discount = data ? data.discountAmount : null
            this.$nextTick(() => {
                this.getpackageData()
            })
        },
        // 询价
        getpackageData () {
            // 询价+传值
            this.$emit('getpackageData', this.formData, 'zero')
        },
        validate () {
            return {
                valid: this.$refs.hpcForm.validate(),
                data: this.formData
            }
        }
    }
}
</script>

<style lang="less" scoped>
.hpc-container {
    width: 100%;
    height: 100%;
    padding: 15px 0px;
    .instance-item {
        display: flex;
        padding-top: 20px;
        border-bottom: 1px dashed #e9e9e9;
        .instance-item-left {
            width: 150px;
            text-align: left;
            padding-top: 8px;
            padding-left: 40px;
            font-size: 12px;
            font-weight: 600;
            .instance-item-icon {
                position: relative;
                right: 6px;
                top: 2px;
                font-size: 14px;
            }
        }
        .instance-item-right {
            width: 850px;
            .rc-label-info {
                font-size: 12px;
                display: flex;
                color: #bbb;
                line-height: 20px;
                margin-top: 5px;
                i {
                    position: relative;
                    top: 1px;
                }
            }
            .refresh-icon {
                cursor: pointer;
            }
        }
    }
}
</style>
